import { IPersonalization } from "~src/redux/typings";

export const isPersonalization = (
  item: IPersonalization | undefined
): item is IPersonalization => {
  return item !== undefined && "profile" in item;
};
